module.exports = __webpack_public_path__ + "static/assets/353f54c246ced8489792d046bf1b649d.svg";